import { sortBy } from 'lodash';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ProjectHoursBillingType } from '@work4all/models/lib/Enums/ProjectHoursBillingType.enum';

import { FixedDataPicker } from '../fixed-data-picker/FixedDataPicker';
import { IPickerProps } from '../types';

export type ProjectHoursBillingTypePickerProps<TMultiple extends boolean> =
  IPickerProps<{ id: ProjectHoursBillingType; name: string }, TMultiple> & {
    filterValues?: string[];
  };

export function ProjectHoursBillingTypePicker<TMultiple extends boolean>(
  props: ProjectHoursBillingTypePickerProps<TMultiple>
) {
  const { filterValues } = props;

  const { t } = useTranslation();

  const dataSet = useMemo(() => {
    return sortBy(
      Object.keys(ProjectHoursBillingType)
        .map((by) => {
          return {
            id: by,
            name: t(`PROJECT_HOURS_BILLING_TYPE.${by}`),
          };
        })
        .filter((x) => (filterValues ? !filterValues.includes(x.id) : true)),
      'name'
    );
  }, [t, filterValues]);

  return <FixedDataPicker {...props} dataSet={dataSet} />;
}
